import Plot from 'features/plotly'
import { Shape } from 'plotly.js'
import React, { FC } from 'react'

import { WATERFALL_COLOR_SCALE } from './waterfallColorscale'

type WaterfallPlotProps = {
  dataValues?: number[][]
  isDScan?: boolean
  minCoord?: number
}

export function rotate(arr: number[][]) {
  const newArr: number[][] = []

  const xLen = arr.at(0)?.length
  if (!xLen) {
    return []
  }
  for (let xIndex = 0; xIndex < xLen; xIndex++) {
    const newRow: number[] = []
    arr.forEach((_, yIndex) => {
      newRow.push(arr[yIndex][xIndex])
    })
    newArr.push(newRow)
  }
  return newArr
}

export function flipY(arr: number[][]) {
  const newArr: number[][] = []
  const yLen = arr.length
  for (let flippedYindex = yLen - 1; flippedYindex >= 0; flippedYindex--) {
    const newRow: number[] = []
    arr[flippedYindex].forEach((val) => {
      newRow.push(val)
    })
    newArr.push(newRow)
  }

  return newArr
}

function constructAScanLine(
  rotate: boolean,
  coord: number,
  length: number
): Partial<Shape> {
  const coords = rotate
    ? {
        y0: coord,
        x0: 0,
        y1: coord,
        x1: length,
      }
    : {
        x0: coord,
        y0: 0,
        x1: coord,
        y1: length,
      }

  return {
    type: 'line', // Type of shape
    ...coords,
    line: {
      color: 'black', // Color of the line
      width: 2, // Width of the line
      dash: 'dash',
    },
  }
}

const WaterfallPlot: FC<WaterfallPlotProps> = (props: WaterfallPlotProps) => {
  const config = {
    displayModeBar: false,
    responsive: true,
  }

  const formattedData = React.useMemo(() => {
    if (props.isDScan) {
      return props.dataValues
    } else {
      return flipY(rotate(props.dataValues ?? []))
    }
  }, [props.dataValues, props.isDScan])

  return props.dataValues ? (
    <div>
      <Plot
        data={[
          {
            z: formattedData,
            type: 'heatmap',
            colorscale: WATERFALL_COLOR_SCALE,
            showscale: false,
            reversescale: false,
            hoverinfo: 'x+y+z',
          },
        ]}
        layout={{
          margin: { t: 0, b: 0, l: 0, r: 0 },
          width: 300,
          height: 300,
          shapes:
            props.minCoord && props.dataValues && props.dataValues.length
              ? [
                  constructAScanLine(
                    !!props.isDScan,
                    props.minCoord,
                    props.dataValues[0].length
                  ),
                ]
              : [],
          xaxis: {
            showticklabels: false,
            ticks: '',
            zeroline: false,
            showline: false,
          },
          yaxis: {
            showticklabels: false,
            ticks: '',
            zeroline: false,
            showline: false,
          },
          plot_bgcolor: 'rgba(0, 0, 0, 0)',
          paper_bgcolor: 'rgba(0, 0, 0, 0)',
        }}
        config={config}
      />
    </div>
  ) : (
    <div />
  )
}

export default WaterfallPlot
